













































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

@Component
export default class PlacaForm extends Vue {

    public placa = "";
    public versao = [];

    public isValid = true;

    public data = "";
    public versaoSelecionada = "";
    public fipe = "";
    public result = [];
    public marca = "";
    public ano = "";

    // public searchFipe() {
    //     axios.get(`http://api.fipeapi.com.br/v1/fipe/${this.versaoSelecionada}?81c3491bd83d67d9ad889cca166ea3d9`)
    //     .then( (response) => {
    //         this.result = response.data[0].tipo
    //     }).catch((error) => console.log(error));
    // }

    // public searchPlaca () {
    //     if (this.placa.length >= 6) {
    //         axios.get(`https://api.wipsites.com.br/dados/placa/${ this.placa }`)
    //         .then( (response) => {
    //             this.versao = response.data.fipes,
    //             this.marca = response.data.marca,
    //             this.ano = response.data.dados_do_veiculo.ano;
    //         }).catch((error) => console.log(error));
    //     }
    // }

    public onClick () {
        window.location.href = `http://localhost:8080/sequencia?placa=${btoa(this.placa)}`;
    //    this.$router.push({
    //         name: 'complemento'
    //     });

    }
}

